import { format, isToday, isTomorrow, setDefaultOptions } from "date-fns";
import { es } from "date-fns/locale";

import Title from "./typography/title";

setDefaultOptions({ locale: es });

type Props = {
  eta: string;
};

export default function Eta({ eta }: Props) {
  const date = formatDate(eta);

  return <Title text={capitalize(date)} />;
}

const timeFormat = "h aaa"; // 5 pm
const dateFormat = `EEEE d 'de' MMMM 'antes de las' ${timeFormat}`; // viernes 19 de abril antes de las 5 pm

function formatDate(date: string) {
  if (isToday(date)) {
    return `hoy antes de las ${format(date, timeFormat)}`;
  } else if (isTomorrow(date)) {
    return `mañana antes de las ${format(date, timeFormat)}`;
  } else {
    return format(date, dateFormat);
  }
}

function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
